import React, { useState } from 'react';
import styled from 'styled-components';
import main_call_img from '../../asset/img/main_call_img.svg';
import Typography from '../../components/common/Typography';
import { useSelector } from 'react-redux';

const FloatingWrapper = styled.div`
  position: fixed;
  bottom: 40px;
  right: 16px;
  z-index: 8;

  padding: 3px 13px 3px 3px;
  align-items: center;
  gap: 4px;
  border-radius: 23px;
  background: var(--GrayScale-0, #fff);

  /* Dropshadow/Primary */
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);

  display: flex;
  cursor: pointer;
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  margin-bottom: 8px;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
`;

const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
};

const FloatingCallConsult = () => {
  const { callcenter } = useSelector(state => state.common);
  const [showTooltip, setShowTooltip] = useState(false);

  const handlePhoneClick = () => {
    if (!callcenter) {
      console.warn('전화번호가 설정되지 않았습니다.');
      return;
    }

    // 모바일이 아닌 환경에서는 툴팁만 보여주기
    if (!isMobile() && !window.ReactNativeWebView) {
      setShowTooltip(prev => !prev);
      return;
    }

    try {
      // 앱 환경 체크 (window.ReactNativeWebView가 있다면 앱 환경)
      if (window?.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'OPEN_URL', // 메시지 타입 수정
            url: `tel:${callcenter}`,
          }),
        );
        return;
      } else {
        //일반 웹 환경
        const telUrl = `tel:${callcenter}`;
        const link = document.createElement('a');
        link.href = telUrl;
        link.click();
      }
    } catch (error) {
      console.error('전화 연결 중 오류가 발생했습니다:', error);
      alert(`상담 전화번호: ${callcenter}`);
    }
  };

  return (
    <FloatingWrapper onClick={handlePhoneClick}>
      {window.innerWidth >= 1024 && showTooltip && callcenter && <Tooltip>{callcenter}</Tooltip>}
      <img src={main_call_img} alt="전화 상담" />
      <Typography className="captionBold">전화 상담</Typography>
    </FloatingWrapper>
  );
};

export default FloatingCallConsult;
